import { FC, SVGProps } from 'react'

export const Warranty: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.5148 2.18998C12.2305 1.93667 11.8014 1.93667 11.5171 2.18998C9.2388 4.2195 6.24149 5.26962 3.18278 5.10835C2.82702 5.0896 2.50716 5.32369 2.41746 5.66846C2.13943 6.73703 1.99915 7.83637 2 8.94009L2 8.94071L2.75 8.94009H2C2 15.0091 6.18062 20.1027 11.8303 21.5461C11.9521 21.5772 12.0798 21.5772 12.2016 21.5461C17.8513 20.1027 22.0319 15.0102 22.0319 8.94009C22.0319 7.81042 21.8867 6.71462 21.6145 5.66847C21.5248 5.32369 21.2049 5.0896 20.8491 5.10835C17.7904 5.26962 14.7931 4.2195 12.5148 2.18998ZM3.5 8.93948C3.49937 8.16142 3.57805 7.38579 3.73457 6.62438C6.74766 6.63857 9.67437 5.61676 12.016 3.73249C14.3576 5.61676 17.2842 6.63856 20.2973 6.62438C20.451 7.37214 20.5319 8.14618 20.5319 8.94009C20.5319 14.2352 16.9296 18.7012 12.016 20.0437C7.10238 18.7012 3.5 14.2342 3.5 8.94009L3.5 8.93948ZM15.633 10.4945C15.927 10.2027 15.9287 9.72781 15.6369 9.43386C15.345 9.13991 14.8702 9.13819 14.5762 9.43003L10.9864 12.994L9.45573 11.4743C9.16178 11.1825 8.68691 11.1842 8.39507 11.4781C8.10324 11.7721 8.10496 12.247 8.3989 12.5388L10.458 14.5831C10.7505 14.8734 11.2224 14.8734 11.5148 14.5831L15.633 10.4945Z"
			fill="currentColor"
		/>
	</svg>
)
